import React from 'react';
import { Building2, Clock } from 'lucide-react';
export function SocialProofSection() {
  return <section className="py-20 bg-[#EDE7F6]" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-center" data-id="element-146">
          <div className="flex flex-col items-center" data-id="element-147">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-148">
              <Building2 size={32} data-id="element-149" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-150">20+</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-151">
              подключенных садов
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-152">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-153">
              <Clock size={32} data-id="element-154" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-155">28.8</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-156">
              часов экономии в неделю
            </p>
          </div>
        </div>
      </div>
    </section>;
}